type AnvokErrorSeverity = "info" | "warn" | "err" | "fatal";

export class AnvokError implements Error {
  public readonly name: string;
  public readonly severity: AnvokErrorSeverity;
  public readonly message: string;
  public readonly data?: object;
  public readonly anvokError: boolean = true;

  public constructor(
    message: string,
    severity?: AnvokErrorSeverity,
    data?: object
  ) {
    this.name = "anvokerror";
    this.message = message;
    this.severity = severity || "err";
    this.data = data;
  }

  public static isAnvokError(error: any): boolean {
    return error instanceof AnvokError || error.anvokError;
  }
}
